import { QueryClient } from '@tanstack/react-query';

/**
 * React Query client configuration
 * Provides default settings for all queries and mutations
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Data is considered fresh for 5 minutes
      staleTime: 5 * 60 * 1000,
      // Cache data for 10 minutes
      gcTime: 10 * 60 * 1000,
      // Retry failed requests once
      retry: 1,
      // Don't refetch on window focus in development
      refetchOnWindowFocus: import.meta.env.PROD,
      // Show error messages
      throwOnError: false,
    },
    mutations: {
      // Retry failed mutations once
      retry: 1,
      // Show error messages
      throwOnError: false,
    },
  },
});

export default queryClient;

